module.exports = __webpack_public_path__ + "img/photoshop.da3d65a7.png";